import { Helmet } from "react-helmet-async";

import ServiceHero from "../components/ServiceHero";
import ChooseTanbio from "../components/ChooseTanbio";
import DiagnosticServices from "../components/DiagnosticServices";

export default function Service() {
  return (
    <>
      <Helmet>
        <title>
          Diagnostic Services | TanBio BioMed Genomics Laboratory
        </title>

        <meta
          name="description"
          content="Explore pathology, microbiology, biochemistry, genomics, molecular diagnostics, preventive health checkups and specialized laboratory services."
        />

        <link rel="canonical" href="https://tanbiomedlab.com/service" />
      </Helmet>

      <section id="service">
        <ServiceHero />
      </section>

      <section id="diagnosticservices">
        <DiagnosticServices />
      </section>

      <section id="whychoose">
        <ChooseTanbio />
      </section>
    </>
  );
}